import AOS from 'aos';
import './utils/vh.utils.js';
import './utils/animate-on-view.utils'

import './components/home-loader.component.js';
import './components/animations.component.js';
import './components/uploadFile.component.js';
import './components/inputs.component.js';
import './components/marquee.component.js';
import './components/inputs.component.js';
import './components/content-sticky.component.js';
import './components/validation.component.js';
import './components/text-sec-rows.component.js';


import './components/sw-government.component.js';
import './components/sw-working.component.js';
import './components/sw-explore.component.js';
import './components/sw-testimonials.component.js';
import './components/sw-range.component.js';
import './components/sw-social-values.component.js';
import './components/sw-senior.component.js';
import './components/sw-jobs-search.component.js';
import './components/sw-job-descr.component.js';
import './components/sw-offices.component.js';
import './components/sw-first-gallery.component.js';
import './components/sw-final.component.js';

import './components/footer.component.js';
import './components/header.component.js';
import './libs/countUp.lib.js';

AOS.init();


function setDVH() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--dvh', `${vh}px`);
}

setDVH();







